import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { postRequest } from "../axios";
import { Button, Spin } from "antd";
import Barcode from "react-barcode";
import QRCode from "react-qr-code";
import moment from "moment";

export default function PrintMultiplePackages() {
  const location = useLocation();
  const printRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [packages, setPackages] = useState([]);

  const query = new URLSearchParams(location.search);
  const ids = JSON.parse(decodeURIComponent(query.get("ids") || "[]"));

  const printStyles = `
  @media print {
    @page {
     size: A4;
      margin: 0mm;
    }
    
    body {
      margin: 0;
      padding: 0;
      font-family: Arial, sans-serif;
    }
    
    /* Hide non-printable elements */
    .no-print {
      display: none !important;
    }
    
    /* Show only print content */
    * {
      visibility: hidden;
    }
    
    .print-label,
    .print-label * {
      visibility: visible;
    }
    
    /* Label container styling */
    .print-label {
      position: relative !important;
width: 100mm !important;
height: 150mm !important;
min-width: 100mm !important;
max-width: 100mm !important;
min-height: 150mm !important;
max-height: 150mm !important;
    top: 0 !important;
        left: 0 !important;
      border: 2px solid black !important;
      box-sizing: border-box !important;
      padding: 0 !important;
        margin: 0 !important;
      background: white !important;
      color: black !important;
      font-family: Arial, sans-serif !important;
      font-size: 4.5pt !important;
      line-height: 0.9 !important;
      overflow: hidden !important;
      page-break-inside: avoid !important;
    }
    
    /* Page break between labels */
    .page-break {
      page-break-after: always !important;
    }
    
      /* Page break between labels */

    
    /* Ensure proper color printing */
    html {
      -webkit-print-color-adjust: exact !important;
      color-adjust: exact !important;
    }
    
    /* Fix for multiple labels */
    .label-wrapper:not(:last-child) {
      page-break-after: always !important;
    }
    
    /* Ensure borders are visible */
    .print-label * {
      -webkit-print-color-adjust: exact !important;
      color-adjust: exact !important;
    }
    
    /* Remove any transforms that might interfere */
    .print-label,
    .print-label * {
      transform: none !important;
      position: static !important;
    }
    
    /* Override any absolute positioning except for necessary elements */
    .print-label > div {
      position: relative !important;
    }
  }
`;

  useEffect(() => {
    // Add print styles to head
    const styleEl = document.createElement("style");
    styleEl.innerHTML = printStyles;
    document.head.appendChild(styleEl);

    return () => {
      // Cleanup
      document.head.removeChild(styleEl);
    };
  }, []);
  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await postRequest(
          "package-model/get-package-by-ids/",
          {
            packages: ids,
          }
        );
        if (response.data.success) {
          setPackages(response.data.data);
        }
      } catch (error) {
        console.error("Failed to fetch packages", error);
      } finally {
        setLoading(false);
      }
    };

    if (ids.length > 0) {
      fetchPackages();
    }
  }, []);

  const handlePrint = () => {
    const footer = document.getElementById("print-footer");
    const currentDateTime = moment().format("DD/MM/YYYY hh:mm:ss A");

    if (!footer) {
      const newFooter = document.createElement("div");
      newFooter.id = "print-footer";
      document.body.appendChild(newFooter);
    }

    document.getElementById(
      "print-footer"
    ).innerHTML = `Printed On: ${currentDateTime}`;
    window.print();
  };

  if (loading) return <Spin />;
  

  const stateToCityCodeMap = {
    "NEW SOUTH WALES": "SYD",
    "NSW": "SYD",
  
    "VICTORIA": "MEL",
    "VIC": "MEL",
  
    "QUEENSLAND": "BNE",
    "QLD": "BNE",
  
    "SOUTH AUSTRALIA": "ADL",
    "SA": "ADL",
  
    "WESTERN AUSTRALIA": "PER",
    "WA": "PER",
    "Australian Capital Territory":"CBR",
    "ACT":"CBR"
  };
  
  return (
    <div>
      <Button
        onClick={handlePrint}
        className="no-print"
        type="primary"
        style={{
          marginTop: "20px",
          backgroundColor: "#f7630c",
          color: "white",
          border: "none",
          padding: "8px 16px",
          fontSize: "13px",
          fontWeight: "bold",
          borderRadius: "6px",
          display: "inline-flex",
          alignItems: "center",
          gap: "6px",
          cursor: "pointer",
          transition: "backgroundColor 0.3s",
        }}
        // style={{ marginTop: "20px",
        //   backgroundColor: "#f7630c",
        //   color: "white",
        //   border: "none",
        //   padding: "8px 16px",
        //   font-size: "13px",
        //   font-weight: "bold" }}
      >
        Print All Labels
      </Button>
      
      <div
        ref={printRef}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding:'16px 0px'
        }}
      >
        {packages.map((pkg, index) => (
          <div
            className={`label-wrapper ${
              index !== packages.length - 1 ? "page-break" : ""
            }`}
            key={pkg.hawb || index}
          >
            <div
              ref={printRef}
              className="print-label"
              style={{
                width: "400px",
                minHeight: "560px",
                padding: "0",
                fontFamily: "Arial, sans-serif",
                backgroundColor: "white",
                color: "#000",
                boxSizing: "border-box",
                border: "2px solid black",
                marginTop: "20px",
                display:"flex",
                flexDirection:'column',
              }}
            >
            
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderBottom: "2px solid black",
                  height: "40px",
                }}
              >
                <div
                  style={{
                    backgroundColor: "black",
                    color: "white",
                    padding: "8px",
                    fontSize: "13px",
                    fontWeight: "bold",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "60px",
                  }}
                >
                  {pkg?.signature ? "" : "ATL"}
                </div>
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    textAlign: "center",
                    flex: 1,
                  }}
                >
                  Hey Couriers
                </div>
                <div
                  style={{
                    backgroundColor: "black",
                    color: "white",
                    padding: "8px",
                    fontSize: "13px",
                    fontWeight: "bold",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "80px",
                  }}
                >
                  {pkg?.zone_name || "N/A"}
                </div>
              </div>

         
              <div
                style={{
                  borderBottom: "1px solid black",
                  padding: "8px",
                  backgroundColor: "white",
                }}
              >
                <div style={{ fontSize: "13px"}}>
                  <strong>Service Name:</strong> Hey Couriers
                </div>
                <div
                  className="hawb-number"
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    marginTop:"3px",
                    letterSpacing: "1px",
                  }}
                >
                  {pkg?.hawb || "N/A"}
                </div>
              </div>

         
              <div
                style={{
                  width: "100%",
                  maxWidth: "100%", 
                  overflow: "visible", 
                  textAlign: "center",
                  padding:"10px",
                  height:"60px"
                }}
              >
                <Barcode
                  value={pkg?.hawb?.trim() || ""}
                  format="CODE128"
                
                  width={Math.min(2, Math.max(1, 150 / (pkg?.hawb?.trim()?.length || 1)))}
                  height={40}
                  displayValue={false}
                  background="#ffffff"
                />
              </div>

           
              <div
                style={{
                  borderBottom: "2px solid black",
                  padding: "5px",
                  // paddingTop:'0px',
                  paddingTop:'10px',
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
              
                <div
                  style={{
                    flex: 1,
                    border: "2px solid black", 
                    borderRadius: "6px",
                    padding: "5px",
                    
                    marginRight: "10px",
                    textAlign: "left",
                  }}
                >
                  <div
                    style={{
                      fontSize: "13px",
                      fontWeight: "bold",
                      marginBottom: "2px",
                    }}
                  >
                    To: {pkg?.customer_name || "N/A"}
                  </div>
                  <div
                    style={{
                      fontSize: "13px",
                      fontWeight: "bold",
                      lineHeight: "1.4",
                    }}
                  >
                    {(() => {
                      const address = pkg?.customer_address || "";
                      const parts = address
                        .split(",")
                        .map((part) => part.trim());

                      let rest = [];
                      let suburbLine = "";
                      let country = "";

                      if (parts.length >= 3) {
                      
                        country = parts[parts.length - 1];
                        suburbLine = parts[parts.length - 2];
                        rest = parts.slice(0, parts.length - 2);
                      } else if (parts.length === 2) {
                       
                        suburbLine = parts[1];

                        rest = [parts[0]];
                      } else {
                      
                        rest = parts;
                      }

                      return (
                        <>
                          {rest.map((line, idx) => (
                            <div key={idx}>{line} </div>
                          ))}

                      
                          {pkg?.suburb && (
                      <div style={{ fontSize: "16px" }}>
                        {pkg?.suburb_name}
                      </div>
                    )}
                          <div>{pkg?.postcode && <>{pkg?.postcode_name}</>}, {country && parts.length >= 3 && <>{country}</>}
</div>
                       
                          <div style={{ marginTop: "1px" }}>
                            <strong>ph:</strong> {pkg?.customer_phone || "N/A"}
                          </div>
                        </>
                      );
                    })()}
                  </div>
                </div>

             
                <div
                  style={{
                    width: "90px",
                    height: "90px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <QRCode
                    value={`Receiver Info:
  Name: ${pkg?.customer_name || "-"}
  Address: ${pkg?.customer_address || "-"}
  Phone: ${pkg?.customer_phone || "-"}
  Email: ${pkg?.customer_email || "-"}`}
                    size={90}
                  />
                </div>
              </div>

            
              <div
                style={{
                  borderBottom: "1px solid black",
                  padding: "8px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ flex: 1 }}>
                  <div
                    style={{
                      fontSize: "13px",
                      fontWeight: "bold",
                      marginBottom: "2px",
                    }}
                  >
                    From: {pkg?.shipper_name || "N/A"}
                  </div>
                  <div style={{ fontSize: "13px", lineHeight: "1.2" }}>
                    <div>{pkg?.shipper_address || "N/A"}</div>
                    <div>
                      {pkg?.shipper_city || "N/A"} {pkg?.shipper_state || "N/A"}{" "}
                      {pkg?.shipper_postcode || "N/A"}
                    </div>
                  </div>
                </div>

                {stateToCityCodeMap[pkg?.shipper_state?.trim()?.toUpperCase()] ?
                <div
                  style={{
                    backgroundColor: "black",
                    color: "white",
                    padding: "8px 12px",
                    fontSize: "13px",
                    fontWeight: "bold",
                    height: "fit-content",
                    marginLeft: "10px",
                  }}
                >
               
                  {stateToCityCodeMap[pkg?.shipper_state?.trim()?.toUpperCase()] || "SYD"}

                </div>:""}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  borderBottom: "1px solid black",
                alignItems:'flex-start'
                }}
              >
              
             
           <div
  style={{
    flex: 1,
    padding: "6px",
    fontSize: "12px",
    lineHeight: "1.2",
    textAlign: "left",
    whiteSpace: "normal",
    wordWrap: "break-word",
  }}
>

  <div style={{ marginBottom: "2px" }}>
    <strong>Reference:</strong> {pkg?.order_no || "N/A"}
  </div>


  {pkg?.delivery_instructions && (
    <div style={{ marginBottom: "2px" }}>
      <strong>Delivery Instructions:</strong>{" "}
      {pkg?.delivery_instructions}
    </div>
  )}


  {pkg?.special_instructions && (
    <div style={{ marginBottom: "2px" }}>
      <strong>Special Instructions:</strong>{" "}
      {pkg?.special_instructions}
    </div>
  )}


  {(pkg?.length || pkg?.width || pkg?.height) && (
    <div style={{ marginBottom: "2px" }}>
      <strong>DIM (cm):</strong>{" "}
      L: {pkg?.length || "N/A"} cm | W: {pkg?.width || "N/A"} cm |
      H: {pkg?.height || "N/A"} cm
    </div>
  )}
</div>
                <div
                  style={{
                    backgroundColor: "black",
                    color: "white",
                    padding: "8px 12px",
                    fontSize: "13px",
                    fontWeight: "bold",
                    marginLeft: "8px",
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
               
                  {stateToCityCodeMap[pkg?.state_name?.trim()?.toUpperCase()] || "SYD"}

                </div>
              
              </div>

           
              <div
                style={{
                  fontSize: "11px",                 
                  padding: "5px 8px",
                  lineHeight: "1.2",
                  flex:"auto"
                }}
              >
                <div style={{ fontWeight: "bold", marginBottom: "2px" }}>
                  Aviation Security and Dangerous Goods Declaration*
                </div>
                <div>
                  *The sender confirms this article may be transported by air,
                  complies with aviation security rules, and contains no
                  dangerous or prohibited items. False declarations are a
                  criminal offence.
                </div>
              </div>

          
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "5px 8px",
                }}
              >
                <div
                  style={{
                    border: "2px solid black",
                    padding: "2px 8px",
                    fontSize: "13px",
                    fontWeight: "bold",
                  }}
                >
                  {pkg?.created_at || "N/A"}
                </div>
                <div
                  style={{
                    border: "2px solid black",
                    padding: "2px 8px",
                    fontSize: "13px",
                    fontWeight: "bold",
                  }}
                >
                  {pkg?.weight + " KG" || "N/A"}
                </div>
                <div
                  style={{
                    border: "2px solid black",
                    padding: "2px 8px",
                    fontSize: "13px",
                    fontWeight: "bold",
                  }}
                >
                  {pkg?.piece_no && pkg?.total_pieces
  ? `${pkg.piece_no} of ${pkg.total_pieces}`
  : pkg?.piece_no
  ? `${pkg.piece_no}`
  : pkg?.total_pieces
  ? `${pkg.total_pieces}`
  : "N/A"}

                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

    
      <div
        id="print-footer"
        className="no-print"
        style={{ fontSize: "10px", marginTop: "10px" }}
      />
    </div>
  );
}
